import { render, staticRenderFns } from "./FormTable.vue?vue&type=template&id=f36bff5c&scoped=true&"
import script from "./FormTable.vue?vue&type=script&lang=js&"
export * from "./FormTable.vue?vue&type=script&lang=js&"
import style0 from "./FormTable.vue?vue&type=style&index=0&id=f36bff5c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36bff5c",
  null
  
)

export default component.exports